import { ModuleConfig } from '@/core/module';
import { nubUserRoutes } from './routes';
import { useNubUserStore } from './stores/nub-user-store';

export const NubUserModule: ModuleConfig = {
    name: 'nub-user',
    routes: nubUserRoutes,
    stores: {
        nubUser: useNubUserStore
    },
    initialize: () => {
        console.log('Nub User module initialized');
    }
};